export { default as ENV } from './env';
export { default as ERRORS } from './errors';
export { default as FAQ } from './faq';
export { default as EVENTS } from './events';

export const SNACKBAR_DURATION = 4000;
export const NAVBAR_HEIGHT = '71px';
export const PAGE_HEIGHT = `calc(100vh - ${NAVBAR_HEIGHT})`;
export const BOTTOM_BAR_OFFSET = '150px';
